import { MobileLayout, LayoutType, BlockRef, MetaType } from "../types"
import {
  actionCreatorGuard,
  reducerActions,
  reducerGuard,
  processActionMeta,
  getArrayReducerGuard
} from "../reducers"

const kind = "seq_exercises"

export type SeqExercise = {
  kind: typeof kind
  version: number
  name: string
  layout: LayoutType
  mobileLayout: MobileLayout
  left: Array<BlockRef>
  right: Array<BlockRef>
  meta: MetaType
}

export const reducerAction = {
  meta: actionCreatorGuard<SeqExercise, MetaType>("meta", kind),
  left: actionCreatorGuard<SeqExercise, Array<BlockRef>>("left", kind),
  right: actionCreatorGuard<SeqExercise, Array<BlockRef>>("right", kind),
  layout: actionCreatorGuard<SeqExercise, LayoutType>("layout", kind),
  mobileLayout: actionCreatorGuard<SeqExercise, MobileLayout>(
    "mobileLayout",
    kind
  ),
  name: actionCreatorGuard<SeqExercise, string>("name", kind)
}

// Type safety to ensure we have a defined action for each property
type ReducerActions = {
  [key in keyof Omit<
    SeqExercise,
    "kind" | "version"
  >]: (typeof reducerAction)[key][0]
}

// Our exported actions
export const seqExerciseAction = Object.fromEntries(
  Object.entries(reducerAction).map(k => [k[0], k[1][0]])
) as ReducerActions

export const seqExerciseReducer = reducerGuard<SeqExercise>(kind)
  .case(...reducerAction.meta)
  .case(...reducerAction.left)
  .case(...reducerAction.right)
  .case(...reducerAction.layout)
  .case(...reducerAction.mobileLayout)
  .case(...reducerAction.name)
  .default((prevState, action: any) => {
    action = processActionMeta(action)

    switch (action?.meta?.prop) {
      case "left":
        return getArrayReducerGuard<SeqExercise, BlockRef>(
          kind,
          "left",
          "BlockRef",
          prevState,
          action
        )
      case "right":
        return getArrayReducerGuard<SeqExercise, BlockRef>(
          kind,
          "right",
          "BlockRef",
          prevState,
          action
        )
    }

    return prevState
  })
